import { useContext, useEffect, useState } from "react"
import { ToolContext } from "../../../core/context/ToolContext";
import { env } from "../../../core/Env";
import { rqx } from "../../../core/request/API";
import moment from "moment";
import axios from "axios";
import { isMobile, isTablet } from "react-device-detect";
import { GetRandomThreeResult } from "../toolUsage/global/Format";

const hcrmSession = JSON.parse(localStorage.getItem('hcrm_session'))
export const RenderAPI = () => {
    const { tool_state } = useContext(ToolContext)
    const { __SESSION, globalLoader, toolOwned, validateAccount, toolShuffle } = tool_state
    const __init = async() => {
        if (hcrmSession !== null) {
            await globalLoader.set(true)

            if (window.atob(__SESSION.data.ainfo.aid).split('_')[1] !== '0') {     
                const res = await axios.get("https://ipapi.co/json/");
                const location = JSON.stringify(res.data)
                const ipaddress = res.data.ip
                let body = {
                    action:"signin",
                    aid: __SESSION.data.ainfo.aid,
                    date: moment(new Date()).format('YYYY-MM-DD'),
                    tool_id: process.env.REACT_APP_TID_BIZ, 
                    location: location,
                    ip_address: ipaddress,
                    device_type: isMobile ? 2 : isTablet ? 3 : 1
                }
                await rqx.post(`<<global>>/${env()}/trail/create`, body)

            }
            //GET TOOL OWNED
            let prms = __SESSION.data.uaccess[0].role_id === 0 ? {aid:__SESSION.data.ainfo.aid, platform:'business' } : {aid:__SESSION.data.ainfo.aid, platform:'business', ref:0, owner_id:__SESSION.data.uaccess[0].owner_id }
            let resTool = await rqx.get(`<<global>>/${env()==='local'?'dev':env()}/tools/owned`, prms)
            toolOwned.set(resTool) 
			if (resTool.length > 3) { 
				const result = GetRandomThreeResult(resTool); 
				toolShuffle.set(result) 
        	} 
            await globalLoader.set(false)
        }
    }

    const [subscribe, setSubscribe] = useState(true)

    useEffect(() => {
        if (subscribe) {
            if (globalLoader.data) {
                __init()
            }
        }
        return () => setSubscribe(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validateAccount.data])
    
    return (
        <></>
    )
}